import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', meta, ...other }, ref) => (
  <React.Fragment ref={ref} {...other}>
    <Helmet>
      <title>{title}</title>
      {meta}
    </Helmet>
    {children}
  </React.Fragment>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
